import { apiWrapper } from 'ccs-ui-components';
import { call, fork, put, takeLatest } from 'redux-saga/effects';
import { headersInstance } from '../../../../common/utils/HeaderUtils';
import { fetchServiceEventSchema } from '../../actions/actionType/services/ServiceEventSchemaActionTypes';
import {
  clearServiceEventSchema,
  fetchServiceEventSchemaFailure,
  getServiceEventSchemaStarted,
  getServiceEventSchemaSuccess
} from '../../actions/sagaActions/services/ServiceEventSchemaSagaActions';
import { FetchServiceEventSchemaFailurePayload, IActiceServiceEventSchema, ISchemaRequest, ServiceEventSchemaRequest } from '../../actions/types/services/GetAllServiceEventSchemaTypes';

/**
 * Call Gets Service Events Schema by API
 * @returns api response
 */
export async function callGetServiceEventSchemaApi(requestObject: ISchemaRequest) {
  return apiWrapper.get<IActiceServiceEventSchema>(
    `${process.env.REACT_APP_API_CONTROL_PLANE_SCHEMA_BASE_URL}/schemas/${requestObject.eventSchemaId}/version/${requestObject.eventSchemaVersion}`,
    headersInstance()
  );
}

export function* getServiceEventSchema({ requestObject }: ServiceEventSchemaRequest) {
  yield put(clearServiceEventSchema());
  yield put(getServiceEventSchemaStarted());
  try {
    const { responseBody: data, isError, error } = yield call(callGetServiceEventSchemaApi, requestObject);
    if (isError) {
      throw error;
    }
    if (data) {
      yield put(getServiceEventSchemaSuccess(data));
    } else {
      throw new Error('No Response');
    }
  } catch (error) {
    const obj: FetchServiceEventSchemaFailurePayload = {
      error: String(error)
    };
    yield put(fetchServiceEventSchemaFailure(obj));
  }
}

/**
 * Saga Effect to consider latest request
 */
export function* fetchServiceEventSchemaSaga() {
  yield takeLatest(fetchServiceEventSchema.FETCH_SERVICE_EVENT_SCHEMA_REQUEST, getServiceEventSchema);
}

export const getServiceEventSchemaSaga = [fork(fetchServiceEventSchemaSaga)];
